import React, { useState } from 'react';
import AiChatPanel from './AiChatPanel';
import logo from '../../assets/Asset 2.png'; 

const AiAssistantWidget = ({ setActiveView }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-5 right-5 z-50">
            {isOpen && <AiChatPanel onClose={() => setIsOpen(false)} setActiveView={setActiveView} />}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="bg-white p-2 rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300"
                aria-label="Open AI Assistant"
            >
                <img src={logo} alt="AI Assistant" className="h-12 w-12" />
            </button>
        </div>
    );
};

export default AiAssistantWidget;